module.exports = __webpack_public_path__ + "img/strategy_contract.59b418fd.svg";